import { create } from "zustand";
import {
  getDemoPromptHeading,
  getDemoPromptMessage,
} from "../constants/demoPrompts";

export const useDemoMinskogStore = create((set, get) => ({
  isDemo: window.location.pathname === "/min-skog/demo/",
  demoBlockPopup: null,
  setIsDemo: (isDemo) => set({ isDemo }),
  setDemoBlockPopup: (demoBlockPopup) => set({ demoBlockPopup }),
  DemoBlockFunctionWrapper: (func, prompt, otherFunc = undefined) => {
    if (get().isDemo) {
      set({
        demoBlockPopup: {
          heading: getDemoPromptHeading(prompt),
          message: getDemoPromptMessage(prompt),
        },
      });
      if (otherFunc) {
        otherFunc();
      }
    } else {
      func();
    }
  },
}));